__webpack_require__.p = "/mi-assets/mi-static/mi-groups-renderer/web-rel-26.6.2-926c3ad-11675/_next/";